interface HeaderAlertProps {
  error?: string;
  success?: string;
  onDismiss: () => void;
}

export default function HeaderAlert({
  error,
  success,
  onDismiss,
}: HeaderAlertProps) {
  if (!error && !success) return null;

  return (
    <div
      className={`ib-header-alert ib-header-alert--${error ? "error" : "ok"}`}
      role={error ? "alert" : "status"}
    >
      <span>{error || success}</span>
      <button
        type="button"
        className="ib-banner-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
